/* Merchant-directed automatic motion. No toggle or stored browser preference. */
(() => {
  const motion = new EventTarget();
  Object.defineProperty(motion, 'matches', {value:false});
  window.nanaMotion = motion;
  document.documentElement.dataset.nanaMotion = 'full';
})();
